import { render, staticRenderFns } from "./c_select.vue?vue&type=template&id=5012b394&scoped=true"
import script from "./c_select.vue?vue&type=script&lang=js"
export * from "./c_select.vue?vue&type=script&lang=js"
import style0 from "./c_select.vue?vue&type=style&index=0&id=5012b394&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5012b394",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5012b394')) {
      api.createRecord('5012b394', component.options)
    } else {
      api.reload('5012b394', component.options)
    }
    module.hot.accept("./c_select.vue?vue&type=template&id=5012b394&scoped=true", function () {
      api.rerender('5012b394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_select.vue"
export default component.exports